const t = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5"><path d="m5.5 23.247 4.052-9.454a.751.751 0 0 0-.689-1.046H5.9a.749.749 0 0 1-.69-1.047L9.8 1.2a.75.75 0 0 1 .687-.45h7.7a.75.75 0 0 1 .585 1.219l-4.05 5.063a.75.75 0 0 0 .586 1.218h3.382a.75.75 0 0 1 .53 1.281Z" fill="none" stroke="currentColor" stroke-linejoin="round"></path></svg>';
export {
  t as default
};
